module.exports = __webpack_public_path__ + "media/icons/icons_stars_inactive_lrg-1cc2e199.svg";